import services from '@/services/ascentiaServiceIndex'
import { PLOTLY_CONSTS as PLC } from '../consts'

const state = {
  plotlyTokens: {},
  dashSelections: null,
}

const mutations = {
  [PLC.UPDATE_PLOTLY_TOKEN]: (state, data) =>
    (state.plotlyTokens = {
      ...state.plotlyTokens,
      [data.type]: data.tokenData,
    }),

  [PLC.UPDATE_DASH_SELECTIONS]: (state, data) => {
    state.dashSelections = data
  },

  [PLC.RESET_DASH_SELECTIONS]: (state, data) => {
    state.dashSelections = data
  },
}

const actions = {
  async [PLC.GET_PLOTLY_TOKEN]({ commit }, { data, type }) {
    const response = await services.plotly.saveData('plotlyToken', {
      selectors: JSON.stringify(data),
      type: type,
    })

    commit(PLC.UPDATE_PLOTLY_TOKEN, {
      tokenData: response.data,
      type: type,
    })
    return response.data
  },

  async [PLC.SAVE_DASH_SELECTIONS]({ commit }, { selections, issueId }) {
    const response = await services.plotly.saveData('dashSelections', {
      maintIssueId: issueId,
      json: JSON.stringify(selections),
    })

    if (response.status === 200) {
      commit(PLC.UPDATE_DASH_SELECTIONS, selections)
    }
  },

  [PLC.CANCEL_DASH_SELECTIONS]({ commit }) {
    commit(PLC.RESET_DASH_SELECTIONS, null)
  },

  async [PLC.SAVE_DASH_SELECTIONS]({ commit }, { selections, issueId }) {
    const response = await services.plotly.saveData('dashSelections', {
      maintIssueId: issueId,
      json: JSON.stringify(selections),
    })

    if (response.status === 200) {
      commit(PLC.UPDATE_DASH_SELECTIONS, selections)
    }
  },

  // eslint-disable-next-line no-unused-vars
  async [PLC.CREATE_ISSUE_DASH]({ commit }, { selections, tail }) {
    return await services.plotly.saveData('createIssueFromDash', {
      IsNew: true,
      json: JSON.stringify(selections),
      tailNumber: tail,
      IsRepeater: true,
    })
  },

  // eslint-disable-next-line no-unused-vars
  async [PLC.REPEATER_RELATEDEVENT_GRID_DASH]({ commit }, data) {
    return await services.plotly.saveData('dashSelections', {
      json: JSON.stringify(data),
      IsRepeater: true,
    })
  },

  [PLC.CANCEL_DASH_SELECTIONS]({ commit }) {
    commit(PLC.RESET_DASH_SELECTIONS, null)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
